import { isWeb } from '@volt-libs/foundation'
import config from './production'

const conf = {
    ...config,
    urls: {
        ...config.urls,
        authUrl: 'https://edsprod.ott.ooredoo.qa:33428',
        proxyUrl: 'https://waf-ooredoo-staging-api.ooredootv.qa/maculosa/v3.1',
        emi: {
            baseUrl: 'https://waf-ooredoo-staging-api.ooredootv.qa/emi',
            homePath: `3.0/{population}/${isWeb ? 1 : 3}`,
            defaultPopulation: 'prod',
        }
    },
    authenticationType: 'iptv',
    authenticationTypeTv: ['iptv'],
    ooredoo: {
        clientId: 'KIbxyh8sTA',
        userAgent: 'OoredooApigw',
        clientKey: 'pJNAdQ0nWVoHeAdnlTjG9jS8Trg3yQjbJ7iImnaKJaqUvx87',
        clientSecret: 'Q106hE3iwWqPIGFNbn3rVlHPGAQl7z7SiUN3ebtsylYax9JnrrI6B6Shz3OuLEYl',
        lmsEnvironment: 'OQ_NG_RES',
        soloToken: "IElZR2JzU01IOUk0aUNrRTdaWkdaN3RueEpDZEZDdTNWY2RxQmR5RWdUVkRHdXhwNzpBRE5LQ05BWUNhSTMxY1R4R3RTbnIzOW5BSFBVNmk4UE9BaDZQVGRGRjFDdTkzaVdnczM4MGlKMkdZYk9JQTNu",
        phoneNumberVisibleDigits: 4, // to get obfuscated phone numbers
        // For debug purposes (TODO: to be removed later)
        // To be removed for official delivery
        // forceIptvAccountNumber: '2110060837641',
        // debugValidateOTP: '0000',
    },
    firebaseConfig : {
        enabled: true,
        debugMode: true,
        apiKey: "AIzaSyBRkOSwBCO-lHE6CwYIjFm9pUUNKgf3YFc",
        authDomain: "ooredootv---dev.firebaseapp.com",
        projectId: "ooredootv---dev",
        storageBucket: "ooredootv---dev.firebasestorage.app",
        messagingSenderId: "973034218194",
        appId: "1:973034218194:web:80b31e06cd077c5ec3430b",
        measurementId: "G-RJLKPXTESY"
    },
    agama: {
        // Agama analytics status
        enable: true,
        //Console URI
        _configuration:"emp_service=https://rtn.castling.qa:8192/report;report_interval=10;id_report_interval=10;operator_id=Ooredoo_0x5E01_VLTN;",
         // player name
        playerName: 'Shaka Player',
        playerVersion: '4.3.8-nmp-2',
        caSystem: 'PlayReady',
        cdn: 'Huawei',
        //DEBUG for development and INFO for Prod.
        verbose:'Agama.LogLevel.FATAL'
    },
    env: 'internalproduction',
    hybridHeight: isWeb ? '135px': '250px',
    watermark: {
        enabled: true,
        strength: 70
    }
}

export default conf
